import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import fr from './locales/fr/translation.json';
import en from './locales/en/translation.json';

const savedLang = localStorage.getItem('kurso_lang') || 'fr';

i18n.use(initReactI18next).init({
  lng: savedLang,
  fallbackLng: 'fr',
  resources: {
    fr: { translation: fr },
    en: { translation: en },
  },
  interpolation: { escapeValue: false },
});

export default i18n;
